import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';

import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import { Modal } from 'react-bootstrap';
import { Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import Select from 'react-select';

import SchedulePeriod from './Elements/SchedulePeriod';


class SchedulesEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      blocked_approval: 0,
      id: null,
      name: null,
      base: null,
      date_start: null,
      date_finish: null,
      company_id: null,
      period_id: null,
      schedule_grades: [],
      schedule_periods: {},
      schedule_grade: {},
      grade: {},
      grade_alternate: {},
      initials_colors: {},
      schedule_days: {},
      period_options: [],
      modal: false,
      modal_alert: false,
      alerts: {},
      verification: 0,
      signing: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.edit = this.edit.bind(this);
    this.loadData = this.loadData.bind(this);
    this.getInfoEscala = this.getInfoEscala.bind(this);
    this.viewAlerts = this.viewAlerts.bind(this);
    this.officialize = this.officialize.bind(this);
    this.verify = this.verify.bind(this);
    this.approve = this.approve.bind(this);
    this.desapprove = this.desapprove.bind(this);
    this.duplicate = this.duplicate.bind(this);
    this.publish = this.publish.bind(this);
    this.returnToDraft = this.returnToDraft.bind(this);
    this.deleteGrade = this.deleteGrade.bind(this);
    this.addPeriod = this.addPeriod.bind(this);
    this.importPeriod = this.importPeriod.bind(this);
    this.export = this.export.bind(this);
    this.blockApproval = this.blockApproval.bind(this);
    this.unblockApproval = this.unblockApproval.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData(1));
    }
  }


  loadData (first_load) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/info/edicao/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/sigla/modelos');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            blocked_approval: responseJson.data.main.blocked_approval,
            name: responseJson.data.main.name,
            base: responseJson.data.main.base.name,
            date_start: responseJson.data.main.date_start_str,
            date_finish: responseJson.data.main.date_finish_str,
            company_id: responseJson.data.main.company_id,
            schedule_grades: responseJson.data.schedule_grades,
            schedule_periods: responseJson.data.schedule_periods,
            period_options: responseJson.data.period_options,
          });
        }
      }).then(() => {
        if(first_load === 1) {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          self.handleMessage();
        }
      });
    });
  }


  // gero os dados do modal de visualização da escala
  getInfoEscala (schedule_grade_id) {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/aeronaves/escaladas/' + schedule_grade_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/sigla/modelos');
        if (responseJson.status === 'success') {
          self.setState({grade: responseJson.data.main});
          self.setState({grade_extra_main: responseJson.data.extra_main});
          self.setState({grade_alternate: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/escala/grade/info/' + schedule_grade_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({schedule_grade: responseJson.data.schedule_grade});
        }
      }).then(() => {
      var url = config.get('api') + '/escala/dias/' + schedule_grade_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({schedule_days: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/siglas/cores';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({initials_colors: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal: true});
      }); /* Overlay */ }); /* info grade */ }); /* dias grade */ }); /* cores iniciais */
    });
  }

  // gero os dados do modal de alertas da grade
  viewAlerts (schedule_grade_id) {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/gerar/alertas/' + self.props.match.params.id + '/' + schedule_grade_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({alerts: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal_alert: true});
      })
    });
  }
  
  // Modal para marcar como verificada
  verify(schedule_grade_id){
    var confirm = window.confirm('Tem certeza que deseja trocar o status dessa grade para verificada?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/verificar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }  }

  // Voltar grade para rascunho
  desapprove(schedule_grade_id){
    var confirm = window.confirm('Tem certeza que deseja trocar o status dessa grade para rascunho?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/reprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Modal para marcar como aprovada
  approve(schedule_grade_id){
    var confirm = window.confirm('Tem certeza que deseja trocar o status dessa grade para aprovada?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/aprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status == 'success') {
            self.loadData(0);
            window.open(config.get('cdn') + '/tmp/' + responseJson.data.export_with_aircraft);       
            window.open(config.get('cdn') + '/tmp/' + responseJson.data.export_without_aircraft);        
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Modal para marcar como verificada
  publish(schedule_grade_id){
    var confirm = window.confirm('Tem certeza que deseja publicar? Após confirmar, não será possível retornar para revisão.');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/publicar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  returnToDraft(schedule_grade_id){
    var confirm = window.confirm('Tem certeza que deseja voltar status para rascunho?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/rascunhar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  duplicate(schedule_grade_id){
    var confirm = window.confirm('Tem certeza que deseja criar uma revisão desta grade?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/duplicar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Tento oficializar a escala
  officialize (schedule_grade_id) {
    var self = this;
    if (window.confirm('Tem certeza que deseja efetivar esta grade? Esta ação é irreversível.')) {
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/efetivar/escala/' + self.props.match.params.id + '/' + schedule_grade_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.loadData(0);
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          } else {
            self.setState({alerts: responseJson.data});
            self.handleAlert(responseJson.message, responseJson.status, 'open');
            self.setState({modal_alert_officialize: true});
          }
        });
      });
    }
  }

  refreshGrades (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grades/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({schedule_grades: responseJson.data});
        }
      }).then(() => {
        self.handleAlert(event.message, event.status, 'open');
      }); /* Overlay */
    });
  }
  
  // Modal para marcar como verificada
  repproveGrade(schedule_grade_id){
    var confirm = window.confirm('Tem certeza que deseja trocar o status dessa grade para rascunho?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/reprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  
  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      company_id: this.state.company_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteGrade (event) {
    var schedule_grade_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa grade?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/' + schedule_grade_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.loadData(0);
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  addPeriod(event) {
    event.preventDefault();
    var datasave = {
      schedule_id: this.state.id,
      name: this.state.name_period,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/periodo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.loadData(0);
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });   
  }

  importPeriod(event) {
    event.preventDefault();
    var datasave = {
      period_id: this.state.period_id,
      schedule_id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/importar/periodo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.loadData(0);
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });   
  }
  blockApproval(event) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/bloquear/' + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({blocked_approval: responseJson.data.blocked_approval});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      })
    });
  }

  unblockApproval(event) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/desbloquear/' + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({blocked_approval: responseJson.data.blocked_approval});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      })
    });
  }
  export(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Editar escala - {this.state.base} - {this.state.name}</h3>
      <Link to="/escalas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      {this.state.blocked_approval === 0 ? 
        <button onClick={self.blockApproval} className="pull-right btn btn-danger button-inline" value={self.state.id}><i className="fa fa-fw fa-warning"></i> Bloquear Escala</button>
        : 
        <button onClick={self.unblockApproval} className="pull-right btn btn-success button-inline" value={self.state.id}><i className="fa fa-fw fa-warning"></i> Desbloquear Escala</button>
      }
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>Data inicial:</label>
              <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Data final:</label>
              <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Empresa:</label>
              <Select
                className="form-field-name"
                name="company_id"
                value={this.state.company_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'company_id')}
                options={[
                  {value: 1, label: 'Omni Táxi Aéreo'},
                  {value: 2, label: 'Omni Helicopters Guyana'},
                ]}
                required
              />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar edição</button>
        </div> 
      </form>
      <hr/>
      <h3 className="page-title">Grades</h3>
      <hr/>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th className="col-md-3 text-center">Revisão</th>
            <th className="col-md-3 text-center">Status</th>
            <th className="col-md-6 text-center">Ações</th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.schedule_grades).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.schedule_grades[k].number}</td>
                <td className="text-center">{self.state.schedule_grades[k].status}</td>
                <td className="text-center">
                  {(self.state.schedule_grades[k].status === 'rascunho') ?  
                    <div>
                      <Dropdown id="export-data">
                        <Dropdown.Toggle bsStyle={'info'} className="button-inline">
                          <i className="fa fa-fw fa-file-pdf-o"></i> Exportar
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/visualizar/' + self.state.schedule_grades[k].id + '/1'}>Visualizar - Com Aeronaves</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Visualizar - Sem Aeronaves</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/us/visualizar/' + self.state.schedule_grades[k].id + '/1'}>Export - With Aircraft</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/us/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Export - Without Aircraft</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/guyana/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Export Guyana - Without Aircraft</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/tome/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Exportar Tomé - Sem Aeronaves</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/alteracoes/' + self.state.schedule_grades[k].id}>Visualizar alterações</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/gestao/visual/' + self.state.schedule_grades[k].id}>Gestão visual</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/colaborador/grupo/' + self.state.schedule_grades[k].id}>Colaboradores por grupo</MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                      <Link to={"/escala/grade/" + self.state.schedule_grades[k].id} className="btn btn-sm btn-success button-inline" ><i className="fa fa-fw fa-pencil"></i> Editar</Link>
                      <button className="btn btn-sm btn-primary button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.verify(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-check"></i> Marcar como verificada</button>
                      <button className="btn btn-sm btn-warning button-inline" onClick={() => { self.viewAlerts(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-warning"></i> Relatório de alertas</button>
                      <button className="btn btn-sm btn-danger button-inline" value={self.state.schedule_grades[k].id} onClick={self.deleteGrade}><i className="fa fa-fw fa-trash"></i></button>
                    </div>
                    : ''
                  }
                  {(self.state.schedule_grades[k].status === 'verificada') ?  
                    <div>
                      <Dropdown id="export-data">
                        <Dropdown.Toggle bsStyle={'info'} className="button-inline">
                          <i className="fa fa-fw fa-file-pdf-o"></i> Exportar
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/visualizar/' + self.state.schedule_grades[k].id + '/1'}>Visualizar - Com Aeronaves</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Visualizar - Sem Aeronaves</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/us/visualizar/' + self.state.schedule_grades[k].id + '/1'}>Export - With Aircraft</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/us/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Export - Without Aircraft</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/guyana/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Export Guyana - Without Aircraft</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/tome/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Exportar Tomé - Sem Aeronaves</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/alteracoes/' + self.state.schedule_grades[k].id}>Visualizar alterações</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/gestao/visual/' + self.state.schedule_grades[k].id}>Gestão visual</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/colaborador/grupo/' + self.state.schedule_grades[k].id}>Colaboradores por grupo</MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                      <button className="btn btn-sm btn-primary button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.approve(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-check"></i> Marcar como aprovada</button>
                      <button className="btn btn-sm btn-danger button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.desapprove(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-close"></i> Voltar para rascunho</button>
                      <button className="btn btn-sm btn-warning button-inline" onClick={() => { self.viewAlerts(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-warning"></i> Relatório de alertas</button>
                    </div>
                    : ''
                  }
                    {(self.state.schedule_grades[k].status === 'aprovada') ?  
                    <div>
                      <Dropdown id="export-data">
                        <Dropdown.Toggle bsStyle={'info'} className="button-inline">
                          <i className="fa fa-fw fa-file-pdf-o"></i> Exportar
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/visualizar/' + self.state.schedule_grades[k].id + '/1'}>Visualizar - Com Aeronaves</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Visualizar - Sem Aeronaves</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/us/visualizar/' + self.state.schedule_grades[k].id + '/1'}>Export - With Aircraft</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/us/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Export - Without Aircraft</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/guyana/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Export Guyana - Without Aircraft</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/tome/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Exportar Tomé - Sem Aeronaves</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/alteracoes/' + self.state.schedule_grades[k].id}>Visualizar alterações</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/gestao/visual/' + self.state.schedule_grades[k].id}>Gestão visual</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/colaborador/grupo/' + self.state.schedule_grades[k].id}>Colaboradores por grupo</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportacao/escala/viagem/' + self.state.schedule_grades[k].id}>Viagens</MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                      {self.state.schedule_grades[k].published === 0 
                        ? 
                        <button className="btn btn-sm btn-default button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.publish(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-envelope"></i> Publicar</button>
                         
                        :
                        <button className="btn btn-sm btn-default button-inline" value={self.state.schedule_grades[k].id} disabled='disabled' onClick={() => self.publish(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-envelope"></i> Publicado</button>
                      }
                      {self.state.schedule_grades[k].published === 0 
                        ? 
                        <button className="btn btn-sm btn-success button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.returnToDraft(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-refresh"></i> Voltar para rascunho</button>
                         
                        : ""
                      }
                      <button className="btn btn-sm btn-primary button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.duplicate(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-refresh"></i> Criar revisão</button>
                      <button className="btn btn-sm btn-warning button-inline" onClick={() => { self.viewAlerts(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-warning"></i> Relatório de alertas</button>
                    </div>
                    : ''
                  }
                    {(self.state.schedule_grades[k].status === 'superada') ?  
                    <div>
                      <Dropdown id="export-data">
                        <Dropdown.Toggle bsStyle={'info'} className="button-inline">
                          <i className="fa fa-fw fa-file-pdf-o"></i> Exportar
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/visualizar/' + self.state.schedule_grades[k].id + '/1'}>Visualizar - Com Aeronaves</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Visualizar - Sem Aeronaves</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/us/visualizar/' + self.state.schedule_grades[k].id + '/1'}>Export - With Aircraft</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/us/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Export - Without Aircraft</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/guyana/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Export Guyana - Without Aircraft</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/tome/visualizar/' + self.state.schedule_grades[k].id + '/2'}>Exportar Tomé - Sem Aeronaves</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/alteracoes/' + self.state.schedule_grades[k].id}>Visualizar alterações</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/gestao/visual/' + self.state.schedule_grades[k].id}>Gestão visual</MenuItem>
                          <MenuItem onSelect={self.export} eventKey={'/exportar/escala/grade/colaborador/grupo/' + self.state.schedule_grades[k].id}>Colaboradores por grupo</MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                      <button className="btn btn-sm btn-warning button-inline" onClick={() => { self.viewAlerts(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-warning"></i> Relatório de alertas</button>
                    </div>
                    : ''
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <hr/>
      <h3>Períodos da escala</h3>
      <hr/>
      <div className="row">
        <div className="col-md-6">
          <form onSubmit={this.addPeriod}>
            <div className="form-group">
              <label>Nome:</label>
              <input type="text" className="form-control" name="name_period" value={this.state.name_period} onChange={this.handleChange.bind(this, 'name_period')} />
            </div>
            <div className="form-group">
              <button type={'submit'} className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar período</button>
            </div>
          </form>
        </div>
        <div className="col-md-6">
          <form onSubmit={this.importPeriod}>
            <div className="form-group">
              <label>Escala a importar:</label>
              <Select
                className="form-field-name"
                name="period_id"
                value={this.state.period_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'period_id')}
                options={this.state.period_options}
                required
              />
            </div>
            <div className="form-group">
              <button type={'submit'} className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Importar de outra escala</button>
            </div>
          </form>
        </div>
      </div>
      <hr/>
      {Object.keys(self.state.schedule_periods).map(function(sp) {
        var period = self.state.schedule_periods[sp];
        return (
          <SchedulePeriod loadData={self.loadData} period={period} date_start={self.state.date_start} date_finish={self.state.date_finish} handleAlert={self.handleAlert} />
        );
      })}
    </div>
  </div>
  <Modal show={self.state.modal_alert} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Alertas de escala</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => { this.setState({modal_alert: false, alerts: {}}); }}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
    {
      (typeof self.state.alerts.base_alerts !== 'undefined') ?
      <div>
        <h4><strong>Mínimos por designação</strong></h4>
        {Object.keys(self.state.alerts.base_alerts).map(function(k) {
          var alert = self.state.alerts.base_alerts[k];
          if (alert.status === 'danger') {
            return(
              <div className={"box-alert box-alert-" + alert.color}>
                <h4><strong>{alert.title}</strong></h4>
                  <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
              </div>
            );
          } else {
            return(
              ''
            );
          }
        })}
        <hr/>
      </div>
      :
      ''
    }
    {
      (typeof self.state.alerts.staff_alerts !== 'undefined') ?
      <div>
        {Object.keys(self.state.alerts.staff_alerts).map(function(nickname) {
          var alerts = self.state.alerts.staff_alerts[nickname];
          return(
            <div>
              <h4><strong>{nickname}</strong></h4>
              {Object.keys(alerts).map(function(k) {
                var alert = alerts[k];
                if (alert.status === 'error') {
                  return(
                    <div className={"box-alert box-alert-" + alert.color}>
                        <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                    </div>
                  );
                } else {
                  return(
                    ''
                  );
                }
              })}
              <hr/>
            </div>
          );
        })}
      </div>
      :
      ''
    }

    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => { this.setState({modal_alert: false, alerts: {}}); }}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>

</div>
    );
  }
}

export default SchedulesEdit;



// WEBPACK FOOTER //
// ./src/Components/Schedules/SchedulesEdit.js